module.exports = __webpack_public_path__ + "static/media/messenger-pro-icon.76628589.svg";